/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_RelatedInputs */

const en_control_related = /** @type {(inputs: Control_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Related guides & next steps`)
};

const zh_control_related = /** @type {(inputs: Control_RelatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相关攻略`)
};

/**
* | output |
* | --- |
* | "Related guides & next steps" |
*
* @param {Control_RelatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_related = /** @type {((inputs?: Control_RelatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_RelatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_related(inputs)
	return zh_control_related(inputs)
});
export { control_related as "control.related" }